<div fxLayout="column" class="page-layout simple fullwidth" fxFlex>
    <div class="content inner-scroll" fusePerfectScrollbar>
        <app-banner-info [rolesCanShowBanner]="rolesCanShowBannerInfo" situation="single-graph"></app-banner-info>
        <app-shared-filters></app-shared-filters>
        <router-outlet></router-outlet>
    </div>
</div>